
import React from 'react';
import { Parallax, Background } from 'react-parallax';
import '../src/react-parallax.css';

export const ReactParallax = (props) => (
  <div>
    <Parallax
      blur={0}
      bgImage={props.src} ///require('path/to/image.jpg')}
      bgImageAlt="hi"
      strength={3}
    >  
      {/* Put some text content here
      or even an empty div with fixed dimensions
      to have a height for the parallax. */}
      <div style={{ width: '100%', aspectRatio: '210 / 297' }} />
    </Parallax>
    {/* <Parallax
      blur={{ min: -15, max: 15 }}
      bgImage={props.src} ///require('path/to/another/image.jpg')}
      bgImageAlt="the dog"
      strength={200}
    >
      Blur transition from min to max
      <div style={{ height: '200px' }} />
    </Parallax> */}
    {/* <Parallax strength={300}>
      <div>Use the background component for custom elements</div>
      <Background className="custom-bg">
        <img src={props.src} alt="fill murray" />
      </Background>
    </Parallax> */}
  </div>
);
